/**
 * Const TP Pagamento
 * @readonly
 * @enum {string}
 */

export const TIPO_PAGAMENTO = {
  BOLETOS: 4,
  DINHEIRO: 1,
  CARTAO_CREDITO: 2,
  PIX: 6,
};
